<template>
	<div class="goods-item" @click="toInfo(info.id)">
		<div class="goods-item-cover">
			<img class="goods-item-image" :src="info.listImage.split(',')[0]" mode="aspectFill"></img>
			<span v-if="isNoStock" class="goods-item-stock-tag">缺货</span>
		</div>
		<div class="goods-item-name one">{{info.name}}</div>
		<div class="goods-item-price">￥<span>{{info.presentPrice}}</span></div>
		<!-- <img v-if="icon == 1" class="goods-item-icon" src="@/assets/images/new.png"/> -->
	</div>
</template>

<script>
	export default {
		name:"goods-item",
		props:{
			info:{
				type: Object,
				required: false,
				default: {}
			},
			icon:{
				type: Number,
				required: false,
				default: 0
			}
		},
		data() {
			return {
				
			};
		},
		computed:{
			isNoStock(){
				const v = this.info && this.info.hasStock;
				return v === false || v === 'false';
			}
		},
		methods:{
			toInfo(id){
				this.$router.push("/goodsinfo?id="+id);
			}
		}
	}
</script>

<style scoped lang="scss">
	
	.goods-item:hover {
	     z-index: 2;
		-webkit-box-shadow: 0 15px 30px rgba(0,0,0,.1);
		box-shadow: 0 15px 30px rgba(0,0,0,.1);
		-webkit-transform: translate3d(0,-2px,0);
		transform: translate3d(0,-2px,0)
	}
	.goods-item{
		width: 317px;
		height: 452px;
		background: #FFFFFF;
		text-align: center;
		margin-bottom: 18px;
		margin-right: 17px;
		cursor: pointer;
		position: relative;
		.goods-item-cover{
			position: relative;
			display: inline-block;
			line-height: 0;
		}
		.goods-item-stock-tag{
			position: absolute;
			left: 18px;
			top: 18px;
			z-index: 1;
			padding: 5px 12px;
			font-size: 13px;
			line-height: 1.2;
			color: #fff;
			background: rgba(100, 100, 102, 0.92);
			border-radius: 4px;
			box-shadow: 0 2px 6px rgba(7, 11, 19, 0.12);
			pointer-events: none;
		}
		.goods-item-icon{
			width: 62px;
			height: 22px;
			position: absolute;
			top: 18px;
			right: 0px;
		}
		.goods-item-image{
			width: 281px;
			height: 281px;
			object-fit: cover;
			padding:18px 18px 0px;
			display: block;
		}
		.goods-item-name{
			padding: 28px 15px 20px;
			width: 287px;
			height: 28px;
			font-size: 20px;
			color: #070B13;
			line-height: 28px;
		}
		.goods-item-price{
			font-size: 15px;
			font-weight: 500;
			color: #E91A12;
			span{
				font-size: 26px;
			}
		}
	}
</style> 